// This module is intended to be replaced by superstore in the future
export function queryRawLocalStorage(key) {
  let data = null;
  try {
    data = window.localStorage.getItem(key);
  } catch (e) {
    data = '';
  }
  return data;
}
export function queryLocalStorage(key) {
  const data = queryRawLocalStorage(key);
  try {
    return JSON.parse(data || 'null');
  } catch (e) {
    return data;
  }
}
export function setRawLocalStorage(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.warn(error);
  }
}
export function setLocalStorage(key, value) {
  try {
    setRawLocalStorage(key, JSON.stringify(value));
  } catch (error) {
    console.warn(error);
  }
}
export const removeLocalStorage = key => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn(error);
  }
};